import axios, { AxiosInstance } from "axios";
import { LiveApiClientConfig } from "./LiveApiClientConfig";
import { LiveApiClientResponses } from './LiveApiClientResponses';

export class LiveApiClient 
{
    private instance: AxiosInstance;

    constructor(
        private config: LiveApiClientConfig
    )
    {
        this.instance = axios.create({ 
            baseURL: this.config.yextBaseApiUrl
        })
    }

    async getFaqs(conceptCode: string)
    {
        return this.instance.get<LiveApiClientResponses.FaqResponse>(
            `/accounts/${this.config.accountNumber}/entities`, 
            {
                params: {
                    v: `${this.config.version.toISOString().substring(0, 10).replace(/\-/g, "")}`,
                    api_key: this.config.apiKey,
                    limit: 50,
                    offset: 0,
                    entityTypes: "FAQ",
                    fields: "name,answer,c_brand,c_activeInAnswers,meta.id",
                    filter: {
                        "c_brand": { "$eq": conceptCode },
                        "c_activeInAnswers": { "$eq": true },
                    }
                }
            }
        );
    }
}